export default function mask() {
    if (document.querySelector("#phone")) {
        $("#phone").mask("(00) 00000-0000");
    }
    if (document.querySelector("#cpf")) {
        $("#cpf").mask("000.000.000-00");
    }
}
